/** subscriptions make free and premium download permissions a little more complicated.
 *  this is just a facade over that to:
 *  - put the permissions info into one var
 *  - make it more human-readable
 */ import ddt from '@wix/da-ddt';
const logger = ddt.createLogger('downloadbutton');
export const FREE_DOWNLOAD_PERMISSIONS = {
    DOWNLOADABLE: 'downloadable',
    NEEDS_SUBSCRIPTION: 'needs_subscription',
    BLOCKED_BY_SUBSCRIPTION: 'blocked_by_subscription'
};
export function getDeviationFreeDownload(deviation) {
    var _deviation_extended;
    const freeDownload = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.download;
    logger.log('free download', freeDownload);
    if (!freeDownload) {
        return {};
    }
    let permission = FREE_DOWNLOAD_PERMISSIONS.DOWNLOADABLE;
    // the only thing preventing a free download is a subscription
    const tierAccess = deviation.tierAccess;
    if (tierAccess === 'locked') {
        permission = FREE_DOWNLOAD_PERMISSIONS.NEEDS_SUBSCRIPTION;
    }
    if (tierAccess === 'locked-subscribed') {
        permission = FREE_DOWNLOAD_PERMISSIONS.BLOCKED_BY_SUBSCRIPTION;
    }
    logger.log('free download', {
        tierAccess,
        permission
    });
    return {
        download: freeDownload,
        permission
    };
}
export const PREMIUM_DOWNLOAD_PERMISSIONS = {
    DOWNLOADABLE: 'downloadable',
    PURCHASABLE: 'purchasable'
};
export function getDeviationPremiumDownload(deviation, isOwner) {
    var _deviation_extended;
    const premiumDownload = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.pcp;
    logger.log('premium download', premiumDownload);
    if (!premiumDownload) {
        return {};
    }
    // purchasing, unblocked subscriptions, and ownership
    // give access to premium downloads
    const purchasedSeparately = premiumDownload === null || premiumDownload === void 0 ? void 0 : premiumDownload.hasUserPurchased;
    const tierAccess = deviation.tierAccess;
    const hasSubscriptionAccess = tierAccess === 'unlocked';
    const hasPremiumAccess = purchasedSeparately || hasSubscriptionAccess || isOwner;
    const permission = hasPremiumAccess ? PREMIUM_DOWNLOAD_PERMISSIONS.DOWNLOADABLE : PREMIUM_DOWNLOAD_PERMISSIONS.PURCHASABLE;
    logger.log('premium download', {
        isOwner,
        purchasedSeparately,
        tierAccess,
        permission
    });
    return {
        download: premiumDownload,
        permission
    };
}

//# sourceMappingURL=permissions.js.map